import React from "react";

import { useWhiteLabel } from "context/WhiteLabelContext";

const Footer = () => {
  const { showBranding } = useWhiteLabel();
  var d = new Date();

  if (!showBranding) {
    return <div className="footer"></div>;
  }

  return (
    <div className="footer">
      <div className="copyright">
        <p>
          Copyright © Designed &amp; Developed by{" "}
          <a href="https://citoplus.com/" target="_blank" rel="noreferrer">
            CitoPlus
          </a>{" "}
          {d.getFullYear()}
        </p>
      </div>
    </div>
  );
};

export default Footer;
